import { cloneDeep, set } from "lodash";

import { IDEAL_FIT_SEARCH_TYPES, JOB_APPLICATION_MATCH_STATUS } from "lookup";
import api from "apiSingleton";

import { isCoveredJobMatchStatusError } from "utils/helpers/match";

const ALLOWED_STATUSES = [
  JOB_APPLICATION_MATCH_STATUS.MATCHED,
  JOB_APPLICATION_MATCH_STATUS.SHORTLISTED,
  JOB_APPLICATION_MATCH_STATUS.PRESHORTLISTED,
  JOB_APPLICATION_MATCH_STATUS.TKSHORTLISTED,
  JOB_APPLICATION_MATCH_STATUS.MOREINFO,
  JOB_APPLICATION_MATCH_STATUS.APPLIED,
  JOB_APPLICATION_MATCH_STATUS.REJECTEDBYCUSTOMER,
  JOB_APPLICATION_MATCH_STATUS.REJECTEDBYMATCHER,
  JOB_APPLICATION_MATCH_STATUS.REJECTEDBYMEMBER,
  JOB_APPLICATION_MATCH_STATUS.ACCEPTED,
  JOB_APPLICATION_MATCH_STATUS.OFFERSENT,
  JOB_APPLICATION_MATCH_STATUS.SKIPPED,
  JOB_APPLICATION_MATCH_STATUS.INTERESTED,
  JOB_APPLICATION_MATCH_STATUS.INTERESTEDFASTTRACK,
];

export function initMatches(jobOpp) {
  if (jobOpp?.matches?.items) {
    const matches = jobOpp.matches?.items
      ?.map((match) => {
        const output = { ...match };

        if (match?.user?.username) {
          output.username = match.user.username;
        }

        return output;
      })
      .filter((el) => ALLOWED_STATUSES.includes(el.status));

    return matches;
  }

  return [];
}

export async function initIdealCandidates({
  jobOpp,
  requiredSkills,
  optionalSkills,
  geoDistance,
  basedOnWorkHistory,
  searchType,
  mainRecordsSource,
}) {
  const idealCandidates = await api.match.listIdealCandidates({
    jobOpportunityId: jobOpp.id,
    limit: basedOnWorkHistory ? 50 : 15,
    requiredTKSkillsToOverride: requiredSkills,
    optionalTKSkillsToOverride: optionalSkills,
    distanceToBound: geoDistance,
    basedOnWorkHistory,
    ignoreBio: searchType === IDEAL_FIT_SEARCH_TYPES.BASIC,
    mainRecordsSource,
  });

  const hits = JSON.parse(
    idealCandidates.data?.listIdealCandidatesForJob?.hits || "[]"
  );

  return hits;
}

export async function createMatch(args) {
  try {
    return await api.match.create({
      input: {
        ...args,
      },
    });
  } catch (error) {
    console.warn(`createMatch error: ${error}`);

    if (isCoveredJobMatchStatusError(error)) {
      throw error;
    }
  }
}

export async function updateMatch(args) {
  try {
    const resp = await api.match.update({
      input: {
        ...args,
      },
    });

    return resp.data?.updateMatch || {};
  } catch (error) {
    console.warn(`updateMatch error: ${error}`);

    if (isCoveredJobMatchStatusError(error)) {
      throw error;
    }
  }
}

export async function removeMatch(applicationId, jobOpportunityId) {
  try {
    await api.match.delete({
      input: {
        applicationId,
        jobOpportunityId,
      },
    });
  } catch (error) {
    console.log("removeMatch error: ", error);
  }
}

export function updateMatchFieldLocally(
  applicationId,
  fieldKey,
  value,
  matches
) {
  const clonedMatches = cloneDeep(matches);
  const matchedIndex = clonedMatches.findIndex(
    (el) => el.applicationId === applicationId
  );
  const newMatchedUser = clonedMatches[matchedIndex];

  if (newMatchedUser) {
    set(newMatchedUser, fieldKey, value);

    clonedMatches[matchedIndex] = { ...newMatchedUser };
  }

  return clonedMatches;
}

export function removeMatchLocally(applicationId, matches) {
  return matches.filter((el) => el.applicationId !== applicationId);
}

export function replaceMatchLocally(match, matches) {
  const clonedMatches = cloneDeep(matches);
  const existingMatchIndex = clonedMatches.findIndex(
    (el) => el.applicationId === match.applicationId
  );

  clonedMatches[existingMatchIndex] = match;

  return clonedMatches;
}
